import { User } from '../auth/User';
import { ApiRoutes, CmsApiBaseRoot } from './ApiRoutes';
import { HttpRequest } from './HttpRequest';

export class CmsAPI {
  static async invalidateWebsiteCacheForTenant(user: User, tenantId: string): Promise<void> {
    if (!CmsApiBaseRoot) throw new Error('NX_PUBLIC_CMS_API_URL is not configured');
    if (!tenantId.trim()) throw new Error('Tenant ID is required to invalidate website cache');

    const baseUrl = CmsApiBaseRoot.replace(/\/$/, '');
    const query = new URLSearchParams({
      page: '1',
      pageSize: '20',
      sortBy: 'name',
      sortDirection: 'asc',
      'filter[tenantId]': tenantId,
    });
    const headers = new Headers({ 'X-Shell-Route': 'cms' });
    const response: unknown = await HttpRequest(
      `${baseUrl}${ApiRoutes.CMS_WEBSITES}?${query}`,
      'GET',
      null,
      headers,
      user,
    );

    if (
      !response ||
      typeof response !== 'object' ||
      !('items' in response) ||
      !Array.isArray(response.items)
    ) {
      throw new Error('Invalid CMS website list response');
    }

    // Collect all valid website IDs for the given tenant
    const websiteIds: string[] = [];
    for (const website of response.items) {
      if (
        website &&
        typeof website === 'object' &&
        'id' in website &&
        typeof website.id === 'string' &&
        website.id.trim()
      ) {
        websiteIds.push(website.id);
      }
    }

    if (websiteIds.length === 0) {
      throw new Error('No website found for the selected tenant');
    }

    await HttpRequest(
      `${baseUrl}${ApiRoutes.CMS_CACHE_INVALIDATE}`,
      'POST',
      { id: websiteIds, cloudfrontPaths: ['/*'], nextJSPaths: [] },
      headers,
      user,
    );
  }
}
